import classNames from 'classnames';
import React from 'react';

import { css } from 'config/emotionCss';

import { Divider } from 'ui/base';

import Filter from './components/Filter';

const filterHeaderStyle = css`
  margin: 14px 30px 20px;

  .filters-header {
    column-gap: 24px;
    row-gap: 8px;
  }
`;

/**
 * @typedef {{
 *    filters: Array<import('./types').Filter>,
 *    onDelete: (id:string, value:any) => void,
 * }} FilterHeaderProps
 */

/**
 * @type {React.FC<FilterHeaderProps>}
 */
const FilterHeader = ({ filters, onDelete, className }) => {
  const nbFilters = filters.reduce((acc, { values = [] }) => acc + values.length, 0);
  const hasFilters = nbFilters > 0;

  return (
    hasFilters && (
      <div className={classNames(filterHeaderStyle, className, 'd-flex flex-column gap-3')}>
        <div className="filters-header d-flex flex-wrap" data-cy="filters-header">
          {filters.map(filter => (
            <Filter key={filter.id} {...filter} onDelete={onDelete} />
          ))}
        </div>
        <Divider className="m-0" />
      </div>
    )
  );
};

export default FilterHeader;
